// extracted by mini-css-extract-plugin
module.exports = {"container":"pay-sdk-payment-list__container___3zN-G"};